import { useState } from "react";
import { Flex, Typography, theme } from "@murm/ant";
import TemplateCard from "./TemplateCard";
import { startTemplates } from "../templates";
import { PENDO_ID, pendoId } from "../../../lib/pendoIds";
import styles from "./TemplateSuggestions.module.css";

const { Title, Text, Link } = Typography;
const INITIAL_COUNT = 3;

const TemplateSuggestions = ({
  onSelectTemplate,
  onHoverTemplate,
  onHoverEnd,
  heading = "Not sure where to start?",
  description = (
    <>
      Select a template and modify the data to make it your own. Templates are
      starting points for common questions like, “How do voters in a place feel
      about an issue?”
    </>
  ),
}) => {
  const { token } = theme.useToken();
  const [showAll, setShowAll] = useState(false);

  const visibleTemplates = showAll
    ? startTemplates
    : startTemplates.slice(0, INITIAL_COUNT);
  const hasMore = startTemplates.length > INITIAL_COUNT;

  return (
    <div>
      <Title level={4} className={styles.heading}>
        {heading}
      </Title>
      <Text type="secondary" className={styles.description}>
        {description}
      </Text>
      <Flex vertical gap={token.marginXS}>
        {visibleTemplates.map((template) => (
          <TemplateCard
            key={template.query}
            segments={template.segments}
            onClick={() => onSelectTemplate(template)}
            onMouseEnter={() => onHoverTemplate?.(template)}
            onMouseLeave={() => onHoverEnd?.()}
          />
        ))}
      </Flex>
      {hasMore && (
        <Link
          {...pendoId(PENDO_ID.SEARCH_TEMPLATES_SHOW_MORE)}
          onClick={() => setShowAll((prev) => !prev)}
          className={styles.toggle}
        >
          {showAll ? "Hide" : "Show more"}
        </Link>
      )}
    </div>
  );
};

export default TemplateSuggestions;
